export default {
    appData(){
        return this.$store.state.globalModule.appData;
    },
    user(){
        return this.$store.state.userModule.user;
    },
    appLoadedOnce(){
        return this.$store.state.loaded;
    },
    innerApp(){
        return this.isAuthed && this.$route.meta.requiresAuth && this.$route.name !== 'confirm';
    },
    pcOnly(){
        return this.$vuetify.breakpoint.mdAndUp;
    },
    phoneOnly(){
        return !this.pcOnly;
    },
    isAuthed(){
        return !!this.$store.state.userModule.user;
    },
    isAdmin(){
        return this.user ? this.user.groupId == 1 : false;
    },
    isLeader(){
        return this.user ? this.user.groupId == 2 : false;
    }
}